/**
 * 웹 1차에서 제공하지 않는 앱 전용 기능 (M-13 · M-14)
 * 안내 문구는 "{기능명}은 앱에서 이용할 수 있어요" 하나로 쓰고 기능명만 바꾼다.
 */
export const APP_ONLY_FEATURES = {
  accountApply: '거래처 신청',
  filteringApply: '필터링 신청',
  additionalFiltering: '추가 필터링',
  missedDrugs: '놓치고 있는 의약품',
  frontPharmacy: '문전약국 설정',
  businessLicenseEdit: '사업자등록증 수정',
  businessInfo: '사용자 사업자 정보 등록',
  contract: '위탁 계약',
  maxMatch: '맥스매치',
} as const;

export type AppOnlyFeatureKey = keyof typeof APP_ONLY_FEATURES;

/** 받침 유무로 "은/는"을 고른다 — "맥스매치는", "위탁 계약은" */
export const withTopicParticle = (word: string) => {
  const last = word.charCodeAt(word.length - 1);
  const isHangul = last >= 0xac00 && last <= 0xd7a3;
  if (!isHangul) return `${word}은`;
  return (last - 0xac00) % 28 === 0 ? `${word}는` : `${word}은`;
};
